module.exports = __webpack_public_path__ + "img/caas2m-m@2.260eb507.jpg";